export default "__VITE_ASSET__DYChOW61__"